/* Calendar-day countdowns share absolute store midnights, never visit start times. */
(() => {
  "use strict";
  if (!customElements.get("gns-daily-clock")) {
    class DailyClock extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        this.deadlines = (this.dataset.midnights || "").split(",").map(Number).filter(Number.isFinite);
        const offset = /^([+-])(\d{2}):?(\d{2})$/.exec(this.dataset.shopOffset || "+00:00");
        this.offset = offset ? (Number(offset[2]) * 3600 + Number(offset[3]) * 60) * (offset[1] === "-" ? -1 : 1) : 0;
        this.nodes = ["hours", "minutes", "seconds"].map((unit) => this.querySelector(`[data-gns-${unit}]`));
        this.tick = () => {
          clearTimeout(this.timer);
          const now = Date.now() / 1000;
          const deadline = this.deadlines.find((value) => value > now) || (Math.floor((now + this.offset) / 86400) + 1) * 86400 - this.offset;
          const remaining = Math.max(0, Math.ceil(deadline - now));
          const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
          this.nodes.forEach((node, index) => { if (node) node.textContent = String(values[index]).padStart(2, "0"); });
          this.setAttribute("aria-label", `${values[0]} hours, ${values[1]} minutes and ${values[2]} seconds remaining today`);
          this.timer = setTimeout(this.tick, 1000 - Date.now() % 1000);
        };
        this.controller = new AbortController();
        document.addEventListener("visibilitychange", this.tick, { signal: this.controller.signal });
        this.tick();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.timer = null;
        this.controller?.abort();
      }
    }
    customElements.define("gns-daily-clock", DailyClock);
  }
  if (!customElements.get("gns-announcement")) {
    customElements.define("gns-announcement", class extends HTMLElement {
      connectedCallback() {
        const update = () => document.documentElement.style.setProperty("--gns-announcement-height", `${this.getBoundingClientRect().height}px`);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this);
        update();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
})();
